module.exports = __webpack_public_path__ + "static/media/cover.b7f91087.png";